import { render, staticRenderFns } from "./VehicleThumbnail.vue?vue&type=template&id=201aa1da"
import script from "./VehicleThumbnail.vue?vue&type=script&lang=js"
export * from "./VehicleThumbnail.vue?vue&type=script&lang=js"
import style0 from "./VehicleThumbnail.vue?vue&type=style&index=0&id=201aa1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports